export const fromEmail = "admin@apex.com"

const dictionary = {
	isOwner: "Do you own the property",
	isOccupier: "Do you occupy the property",
	grossAreaInSqFt: "What is the gross floor area in sq. ft",
	buildingType: "What type of building is it",
	ageOfBuilding: "Building Age",
	numberOfFloors: "Number of floors",
	builtMaterials:
		"Is your home built and roofed only with bricks, stone and/or concrete?",
	occupancy: "Do you occupy the residence",
	yearBuilt: "Year Built",
	previousLoss:
		"Did you suffer in the past three years any loss for any of the risks proposed to be covered by this insurance?",
	refusedPersonalPropertyInsurance:
		"Have you ever been declined, refused to renew, cancelled, and/or required special terms (or additional premiums) for any of the insurance sections now proposed?",
	directMarketing: "Wishes to recieve direct marketing?"
}

export const payment = data => {
	const { toEmail, insuredName, paymentLink, context } = data

	// prettier-ignore
	const englishContent = `
    Dear ${context.holder.name}<br /><br />
    Thank you for your patience. The underwriting process for your application has been completed. <br />
    Please kindly proceed to the payment process by clicking into the following website link. <br/><br/>
    <a style="font-size:18px;font-weight:700;" href="${paymentLink}" title="Proceed with the payment">Proceed with the payment</a>
    <br/><br/>
    After payment, your relevant policy documents shall be sent to you by email shortly.
    <br/>
	`

	return {
		from: `${fromEmail}`,
		to: `${toEmail}`,
		subject: `Application for "${context.acceptedOffer.product.name}"`,
		htmlContent: `${englishContent}`
	}
}

/**
 * generate quote email for insurer
 * @param {*} context
 */
export const generateQuoteEmailForInsurer = ({
	product,
	holder,
	otherHolders,
	insured,
	acceptedOffer,
	values
}) => {
	// helper function
	const getValueFromDictionary = key => dictionary[key] || key

	const contentFor = (insured, options = { title: false }) => {
		const isIndividual = insured.__typename === "individual"
		const isObject = insured.__typename === "object"

		// prettier-ignore
		const renderTitle = isIndividual ? "<u>Insured Person</u>"
											: isObject ? "<u>Insured Object</u>" : null

		// prettier-ignore
		const renderName = `${insured?.englishFirstName} ${insured?.englishLastName}`

		const renderSalutation = `${insured?.salutation}`

		const renderContacts = insured?.contacts
			?.map(contact => `${contact.type}: ${contact.value}`)
			.join("<br />")

		const renderIdentities = insured?.identities
			?.map(identity => `${identity.type}: ${identity.value}`)
			.join("<br />")

		const renderFacts = insured?.facts
			?.map(fact => {
				if (fact.type === null) return ""
				if (fact.value === null) return `${fact.type}: "N/A`

				const value = Object.values(fact.value).find(value => value !== null)
				return `${getValueFromDictionary(fact.type)}: ${value.toString()}`
			})
			.join("<br />")

		const renderAddresses = insured.addresses
			?.map(address => {
				const values = Object.values(JSON.parse(address.fields)).join(" ")
				return `${address.type}: ${values}`
			})
			.join("<br />")

		const what = []

		// push fields to be rendered
		if (options.title) what.push(renderTitle)
		if (isIndividual) what.push(renderName)
		if (isIndividual && insured?.salutation) what.push(renderSalutation)

		const content = [
			renderContacts,
			renderIdentities,
			renderFacts,
			renderAddresses
		]

		what.push(...content)

		return `${(fields => {
			return `${fields.filter(field => !!field).join("<br />")}`
		})(what)}`
	}

	const u = string => `<u>${string}</u>`

	const proposalValues = values?.map(({ key, value }) => {
		if (!value) throw new Error("There is an empty field")

		const filterNullFromScalar = scalar => {
			return Object.entries(scalar).find(([key, value]) => {
				return value !== null
			})
		}

		let scalar = filterNullFromScalar(value)

		const getValueFromScalar = scalar => {
			const [scalarKey, scalarValue] = scalar

			if (scalarKey !== "arrayValue" && scalarKey !== "objectValue")
				return scalar

			if (scalarKey === "arrayValue") {
				const arr = scalarValue

				const valuesInArray = arr.map(item => {
					const [k, v] = filterNullFromScalar(item)

					if (k !== "objectValue") return v

					return [
						...v.map(context => {
							return {
								key: context.key,
								value: filterNullFromScalar(context.value)[1]
							}
						})
					]
				})

				return [null, ...valuesInArray]
			}
		}

		const [k, v] = getValueFromScalar(scalar)

		return { key, value: v }
	})

	// render email
	return `
		${u("Proposal")}<br />
		${proposalValues
			.map(
				({ key, value }) =>
					`- ${getValueFromDictionary(key)}: ${
						typeof value === "object"
							? value
									.map(val =>
										typeof val === "string"
											? val
											: `<br />&emsp;${getValueFromDictionary(val.key)}: ${
													val.value
											  }`
									)
									.join("")
							: value
					}`
			)
			.join("<br />")}<br /><br />

		${u("Product")}<br />
			Product Name: ${acceptedOffer.product.name}<br />
			Insurer: ${acceptedOffer.product.insurer.name}<br /><br />

		${u("Accepted Offer")}<br />
			Applied Taxes: <br />
				${
					acceptedOffer.premium.appliedTaxes?.length > 0
						? acceptedOffer.premium.appliedTaxes?.map(
								tax => `* ${tax.name}: ${tax.formattedFlat}<br />`
						  )
						: "N/A <br />"
				}
			Applied Discounts: <br />
				${
					acceptedOffer.premium?.appliedDiscounts?.length > 0
						? acceptedOffer.premium?.appliedDiscounts?.map(
								discount =>
									`* ${discount.code}: ${discount.formattedFlat}<br />`
						  )
						: "N/A <br />"
				}
			Accepted Offer Premium: ${acceptedOffer.premium.formattedPrice ||
				"N/A"}<br /><br />

		${u("Holder")}<br />
			${holder ? contentFor(holder) : "N/A"}<br /><br />

		${
			otherHolders.length > 0
				? `${u("Additional Holders")}\n${otherHolders?.map(otherHolder =>
						contentFor(otherHolder)
				  )}<br /><br />`
				: ""
		}

		${
			insured?.length > 0
				? insured.map(i => contentFor(i, { title: true }))
				: "Insured: N/A"
		}<br />
	`
}
